import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import moment from "moment";
import TableActions from "./table-actions";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils";
import TableHeadText from "src/shared/components/table-head";
import SecondaryChip from "src/shared/components/secondary-chip";

const SalesInvoicesTable = ({
  rows,
  isLoading,
  refetch,
}: {
  rows: any;
  isLoading: boolean;
  refetch: Function;
}) => {
  const emptyDataArr = rows?.length === 0;
  const { t } = useTranslation("addSales");
  const { t: generalT } = useTranslation("general");

  const HeadText = [
    generalT("reference"),
    generalT("branch"),
    t("client"),
    generalT("subtotal"),
    generalT("discount"),
    generalT("tax"),
    generalT("total"),
    generalT("paymentMethod"),
    generalT("paymentDate"),
    generalT("invoiceDate"),
    generalT("dueDate"),
    // t("inventory"),
    t("creditNote"),
    generalT("createdAt"),
    generalT("createdBy"),
    generalT("zatcaStatus"),
    generalT("invoiceStatus"),
    generalT("paymentStatus"),
    generalT("actions"),
  ];

  return (
    <Box overflow={"auto"} maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <TableContainer component={Paper} variant="outlined">
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {HeadText.map((item) => (
                <TableCell
                  key={item}
                  align="center"
                  sx={{ bgcolor: "#F9FAFB" }}
                >
                  <TableHeadText text={item} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <TableLoadingSkeleton rowsLength={5} cellsLength={21} />
          ) : (
            <TableBody>
              {rows?.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.reference}</TableCell>
                  <TableCell align="center">{row.branch_name}</TableCell>
                  <TableCell align="center">{row.client_name}</TableCell>
                  <TableCell align="center">
                    {formatNumber(row.amount)}
                  </TableCell>
                  <TableCell align="center">
                    {formatNumber(row.discount)}
                  </TableCell>
                  <TableCell align="center">{row.tax}</TableCell>

                  <TableCell align="center">{row.total}</TableCell>
                  <TableCell align="center">{row.payment_method}</TableCell>
                  <TableCell align="center">{row.payment_date}</TableCell>
                  <TableCell align="center">{row.invoice_date}</TableCell>
                  <TableCell align="center">{row.date}</TableCell>
                  {/* <TableCell align="center">{row.branch_name}</TableCell> */}
                  <TableCell align="center"></TableCell>
                  <TableCell align="center">
                    {moment(row.created_at, "YYYY-MM-DD HH:mm A").format(
                      "YYYY-MM-DD",
                    )}
                  </TableCell>
                  <TableCell align="center">{row.created_by?.name}</TableCell>
                  <TableCell align="center">
                    <SecondaryChip
                      label={row.zatca_status}
                      variant={
                        row.zatca_status === "NA"
                          ? "info"
                          : row.zatca_status === "approved"
                            ? "success"
                            : row.zatca_status === "draft"
                              ? "warning"
                              : "error"
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <SecondaryChip
                      label={row.invoice_status}
                      variant={
                        row.invoice_status === "submitted"
                          ? "info"
                          : row.invoice_status === "draft"
                            ? "warning"
                            : "error"
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <SecondaryChip
                      label={
                        row.payment_status === "Paid"
                          ? generalT("paid")
                          : row.payment_status === "Partly Paid"
                            ? generalT("partiallyPaid")
                            : row.payment_status === "UnPaid"
                              ? generalT("unpaid")
                              : generalT("overpaid")
                      }
                      variant={
                        row.payment_status === "Paid"
                          ? "success"
                          : row.payment_status === "Partly Paid"
                            ? "warning"
                            : "error"
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TableActions row={row} refetch={refetch} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {emptyDataArr && <NoData />}
      </TableContainer>
    </Box>
  );
};
export default SalesInvoicesTable;
